/** Wheel step (hours) for the development-hours table (sugestie cmuzontxd). */
export const HOURS_WHEEL_STEP = 0.25;

/**
 * Next value when scrolling an hours input. Values off the 0.25 grid
 * (e.g. 0.35) snap to the next grid value in the scroll direction
 * (0.35 -> 0.5 up, 0.25 down). Never goes below 0.
 */
export function stepHours(value: number, direction: 'up' | 'down', step: number = HOURS_WHEEL_STEP): number {
  const current = Number.isFinite(value) && value > 0 ? value : 0;
  const units = current / step;
  const EPS = 1e-9;
  const next = direction === 'up'
    ? (Math.floor(units + EPS) + 1) * step
    : (Math.ceil(units - EPS) - 1) * step;
  return Math.max(0, Math.round(next * 1000) / 1000);
}
